import {
  AnnouncementTarget,
  type HelpsQueryVariables,
  type NoticesQueryVariables,
  type TastesServiceLangQueryVariables,
} from '../../graphql/generated/types';
import {ADAPTER_QUERY_KEY_PREFIX} from '../constant';

/**
 * App 도메인 Query Key 관리
 */
export const APP_QUERY_KEY_MAP = {
  /**
   * 도움말 목록 조회
   * Origin: useHelpsQuery.getKey
   */
  helps: (variables?: HelpsQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'helps'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'helps', variables] as const),
  /**
   * 취향 서비스 언어 설정 조회
   * Origin: useTastesServiceLangQuery.getKey
   */
  tastesServiceLang: (variables?: TastesServiceLangQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'tastesServiceLang'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'tastesServiceLang', variables] as const),
  /**
   * 공지 목록 조회
   * Origin: useNoticesQuery.getKey
   */
  notices: (variables?: NoticesQueryVariables) =>
    variables === undefined
      ? ([ADAPTER_QUERY_KEY_PREFIX, 'notices'] as const)
      : ([ADAPTER_QUERY_KEY_PREFIX, 'notices', variables] as const),
} as const;

/**
 * App 도메인 Mutation Key 관리
 *
 * Mutation은 일반적으로 getKey가 없어서 문서화 목적으로만 정의
 */
export const APP_MUTATION_KEY_MAP = {
  /**
   * 앱 설정
   * Origin: useAppSettingMutation (getKey 없음)
   */
  appSetting: 'appSetting',
} as const;

export const AnnouncementTargetToParamMap: {
  [key in AnnouncementTarget]: string;
} = {
  [AnnouncementTarget.Android]: 'android',
  [AnnouncementTarget.Ios]: 'ios',
  [AnnouncementTarget.All]: 'all',
};
